<div class="customer-info-appointment-container">
  <div class="appointment-details-container">
    @if (!isAppointmentPassed) {
      <div class="button-row">
        <ng-casto-button
          class="secondary"
          [faIcon]="faPen"
          [label]="'generic.update'|translate"
          (click)="editAppointment()"></ng-casto-button>
        <ng-casto-button
          class="secondary"
          [faIcon]="faTrash"
          [label]="'generic.delete'|translate"
          (click)="warningDeleteDialogVisible = true"></ng-casto-button>
      </div>
    }
    <div class="appointment-detail-container" #customerName>
      <div class="icon">
        <fa-icon [icon]="faUser"></fa-icon>
      </div>
      <div class="data">
        <span class="title" [innerHTML]="'customer-info.appointment.customer'|translate">
        </span>
        <span class="value">
          {{ customerFullName }}
        </span>
      </div>
      <div class="action">
        <ng-casto-button [faIcon]="copyEnded ? faCheck : faCopy" class="primary" (click)="copyCustomerName()"
                         [loading]="copyLoading"></ng-casto-button>
      </div>
    </div>
    <div class="appointment-detail-container" #hours>
      <div class="icon">
        <fa-icon [icon]="faClock"></fa-icon>
      </div>
      <div class="data">
        <span class="title" [innerHTML]="'customer-info.appointment.hours'|translate">
        </span>
        <span class="value">
          {{ displayedAppointmentHours }}
        </span>
      </div>
    </div>
    <div class="appointment-detail-container" #service>
      <div class="icon">
        <fa-icon [icon]="faList"></fa-icon>
      </div>
      <div class="data">
        <span class="title" [innerHTML]="'customer-info.appointment.service'|translate">
        </span>
        <span class="value">
          {{ appointment?.extendedProps.service.name }}
        </span>
      </div>
    </div>
    <div class="appointment-detail-container" #vendor>
      <div class="icon">
        <fa-icon [icon]="faUser"></fa-icon>
      </div>
      <div class="data">
        <span class="title" [innerHTML]="'customer-info.appointment.vendor'|translate">
        </span>
        <span class="value">
          {{ appointment?.extendedProps.managed_by }}
        </span>
      </div>
    </div>
    <div class="appointment-detail-container" #comment>
      <div class="icon">
        <fa-icon [icon]="faComment"></fa-icon>
      </div>
      <div class="data">
        <span class="title" [innerHTML]="'customer-info.appointment.comment'|translate">
        </span>
        <span class="value">
          @if (appointment?.extendedProps.comment) {

            {{ appointment?.extendedProps.comment }}
          } @else {
            <span class="no-comment" [innerHTML]="'customer-info.appointment.no-comment'|translate"></span>
          }
        </span>
      </div>
    </div>
  </div>
</div>

<p-dialog [header]="'appointment.warning.title'|translate" [modal]="true" [(visible)]="warningDeleteDialogVisible"
          [styleClass]="'appointment-warning-modal'" [draggable]="false">
  <div class="appointment-warning-container">
    <div class="appointment-warning-body">
      <span class="blue" [innerHTML]="'appointment.warning.date'|translate:{
      date:displayAppointmentDate
      }"></span>
      <span class="body-text" [innerHTML]="'appointment.warning.warning-delete-text'|translate"></span>
    </div>
    <div class="actions-footer">
      <ng-casto-button class="secondary" [label]="'generic.cancel'|translate"
                       (click)="warningDeleteDialogVisible = false" />

      <ng-casto-button class="primary" [label]="'generic.delete'|translate" (click)="deleteAppointment()"
                       [disabled]="deleteAppointmentLoading" [loading]="deleteAppointmentLoading" />

    </div>
  </div>
</p-dialog>
